export default {"src":"/_next/static/media/ic_new_logo_skillz.aa2e6d4e.svg","height":24,"width":28,"blurWidth":0,"blurHeight":0};